// How the timeline and routes list order routes. A per-browser preference held in the
// Timeline store (not a backend setting), so these are defined here rather than generated.
export enum RouteSortKey {
  ROUTE_NAME = 'ROUTE_NAME',
  PLANNED_START_TIME = 'PLANNED_START_TIME',
}

export enum RouteSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface RouteSort {
  key: RouteSortKey;
  direction: RouteSortDirection;
}

export const DEFAULT_ROUTE_SORT: RouteSort = {
  key: RouteSortKey.ROUTE_NAME,
  direction: RouteSortDirection.ASC,
};
